const KHUB_LOGO_COLOR = '#0085FF';
const STAMP_STAGGER_MS = 130;

/**
 * Khub logo inlined from public/img/custom/logo.svg — an <img> cannot animate
 * individual SVG paths, and the thinking effect stamps the dashes one by one.
 */
const LOGO_DASHES = [
  'M614 1882 c-15 -9 -74 -127 -74 -147 0 -18 136 -89 156 -81 17 6 74 119 74 146 0 15 -18 29 -70 55 -78 39 -71 37 -86 27z',
  'M1494 1882 c-6 -4 -48 -80 -93 -169 -45 -90 -83 -163 -86 -163 -3 0 -77 36 -165 80 -88 44 -167 80 -175 80 -18 0 -89 -136 -81 -156 7 -18 483 -256 504 -252 18 4 265 494 256 509 -4 8 -137 79 -146 79 -2 0 -8 -4 -14 -8z',
  'M1805 1640 c-19 -38 -35 -74 -35 -80 0 -11 132 -80 155 -80 13 0 85 125 85 150 0 11 -132 80 -155 80 -8 0 -30 -30 -50 -70z',
  'M395 1460 c-19 -38 -32 -75 -30 -82 3 -8 78 -50 166 -93 88 -44 163 -83 165 -86 2 -4 -32 -82 -76 -173 -44 -92 -80 -171 -80 -176 0 -14 140 -82 156 -76 15 6 254 477 254 501 0 17 -467 255 -500 255 -14 0 -29 -18 -55 -70z',
  'M1656 1338 c-8 -13 -65 -125 -127 -250 -98 -196 -111 -228 -99 -242 14 -18 475 -246 496 -246 13 0 84 127 84 150 0 5 -76 48 -170 95 -93 47 -170 87 -170 90 0 3 36 77 80 165 44 88 80 167 80 175 0 13 -125 85 -150 85 -5 0 -16 -10 -24 -22z',
  'M841 584 c-66 -135 -121 -252 -121 -260 0 -17 135 -85 154 -78 6 2 48 77 91 165 44 88 83 163 87 165 4 3 79 -32 167 -76 89 -44 168 -80 176 -80 18 0 89 136 81 156 -6 14 -476 254 -500 254 -8 0 -63 -101 -135 -246z',
  'M402 585 c-18 -36 -32 -73 -32 -83 0 -18 114 -82 145 -82 18 0 89 136 81 156 -6 16 -118 74 -144 74 -12 0 -28 -21 -50 -65z',
  'M1663 468 c-14 -18 -63 -128 -63 -142 0 -15 144 -86 157 -78 14 9 73 128 73 147 0 8 -30 30 -70 50 -77 39 -83 40 -97 23z',
];

interface AnimatedKhubLogoProps {
  /** Stamps the logo dashes one after another while the agent is working */
  animate?: boolean;
  className?: string;
}

export const AnimatedKhubLogo = ({
  animate = false,
  className,
}: AnimatedKhubLogoProps) => (
  <svg viewBox="0 0 227 220" className={className} role="img" aria-label="Khub">
    <g
      transform="translate(0,220) scale(0.1,-0.1)"
      fill={KHUB_LOGO_COLOR}
      stroke={KHUB_LOGO_COLOR}
    >
      {LOGO_DASHES.map((dash, index) => (
        <path
          key={dash}
          d={dash}
          className={animate ? 'motion-safe:animate-logo-stamp' : undefined}
          style={
            animate
              ? {
                  animationDelay: `${index * STAMP_STAGGER_MS}ms`,
                  // 'both' shows the 0% frame (invisible) during the stagger
                  // delay, so the first cycle stamps in sequence too
                  animationFillMode: 'both',
                  transformBox: 'fill-box',
                  transformOrigin: 'center',
                }
              : undefined
          }
        />
      ))}
    </g>
  </svg>
);
